import React, { useCallback, useEffect, useRef, useState } from 'react'

import { DiscountBar } from './DiscountBar/DiscountBar'
import { Box, useTheme } from '@gousto-internal/citrus-react'
import { RafCampaignDetails } from '../../hooks/useFetchRafCampaignDetails'
import { redirectToWizard } from '../../util/redirectToWizard'
import {
  HeaderStickyPromoBannerTrackingEvent,
  RafTrackingEventType,
  StickyTrackingEvent,
} from '../../tracking/trackingConfig'
import { queueTrackingEvent } from '@library/tracking-integration'

export const PromoBanner = ({
  firstBoxDiscount,
  secondBoxDiscount,
}: Omit<RafCampaignDetails, 'giftYourFriendCredit'>) => {
  const stickyBarRef = useRef<HTMLDivElement>(null)
  const [isSticky, setIsSticky] = useState(false)
  const [isHidden, setIsHidden] = useState(true)
  const { theme } = useTheme()
  const breakpointFromMedium = Number(theme.tokens.breakpoints[0].replace('px', ''))

  const onScroll = useCallback(() => {
    const bannerContainer = stickyBarRef.current
    setIsHidden(!(bannerContainer && window?.scrollY > bannerContainer?.offsetTop))
    setIsSticky(bannerContainer ? window?.pageYOffset > bannerContainer?.offsetTop : false)
  }, [])

  useEffect(() => {
    window.addEventListener('scroll', onScroll)

    if (window.innerWidth >= breakpointFromMedium) {
      queueTrackingEvent<RafTrackingEventType>(
        StickyTrackingEvent({ isVisible: isSticky, name: 'sticky_promobanner_state_change' }),
      )
    }

    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  }, [isSticky, onScroll, breakpointFromMedium])

  return (
    <Box ref={stickyBarRef} data-testid="StickyPromoBanner">
      <DiscountBar
        applyDiscount={() => redirectToWizard(HeaderStickyPromoBannerTrackingEvent)}
        isHidden={isHidden}
        isSticky={isSticky}
        promoText={`Get ${firstBoxDiscount}% off your first box and ${secondBoxDiscount}% off all boxes in your first two months`}
      />
    </Box>
  )
}
